import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';
import Stepper from '../Stepper';
import {
  selectRegistrationCurrentStep,
  selectRegistrationInfo,
} from '../../../../store/selectors';
import StepThree from './steps/StepThree';
import { CONSUMER_SITE_BASE_URL } from '../../../../constants';

const propTypes = {
  currentStep: PropTypes.oneOf([0, 1, 2]).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string,
    header: PropTypes.string,
    main: PropTypes.string,
    actionsRow: PropTypes.string,
    inner: PropTypes.string,
  }).isRequired,
  registrationInfo: PropTypes.shape({
    fullName: PropTypes.string,
  }).isRequired,
};

const headings = [
  'myHardies Registration',
  'Review Your Application',
  'Pending Approval',
];

export const Header = props => {
  const {
    classes,
    currentStep,
    registrationInfo: { fullName },
  } = props;

  const getFirstName = () => {
    if (fullName) {
      const nameSegments = fullName.split(' ');
      return ` ${nameSegments.shift()}`;
    }

    return '';
  };

  const renderNormalHeader = () => (
    <div className={classes.root}>
      <div className={classes.inner}>
        <h1 className={classes.heading}>{headings[currentStep]}</h1>
        <div className={classes.main}>
          <div className={classes.leftCol}>
            <div className={classes.leftColFirstRow}>
              You&rsquo;re nearly done{getFirstName()}.
            </div>
            <div className={classes.leftColSecondRow}>
              Confirm your details to activate account.{' '}
              {currentStep === 1 && (
                <>
                  By confirming I acknowledge I have read the{' '}
                  <a
                    href={`${CONSUMER_SITE_BASE_URL}/collection-statement-builder`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Collection Statement
                  </a>
                </>
              )}
            </div>
          </div>
          <div className={classes.rightCol}>
            <Stepper />
          </div>
        </div>
      </div>
    </div>
  );

  switch (currentStep) {
    case 0:
    case 1:
      return renderNormalHeader();
    case 2:
      return <StepThree />;
    default:
      return renderNormalHeader();
  }
};

Header.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  currentStep: selectRegistrationCurrentStep(),
  registrationInfo: selectRegistrationInfo(),
});

export default withStyles(styles)(connect(mapStateToProps)(Header));
